exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 575px) {\n.row[data-v-78f9ac91]{\n        flex-direction: column-reverse;\n}\n}\n.container[data-v-78f9ac91] {\n    background-image: initial;\n}\n\n", ""]);

// exports
